export default __webpack_public_path__ + "static/media/avatar_7_1.dd6d29fe.png";